import React, { useState } from 'react'
import {
  Box,
  Avatar,
  Typography,
  Collapse
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { LFWeb } from 'src/assets/leadFinder/LFWeb'
import { maskEmail } from 'src/utils/util'

export const PersonListTab = ({
  user
  // handleAddToListClick,
  // handleAddToCampaignClick,
  // isConfirmingLeads
}) => {
  const [isContactInfoOpen, setIsContactInfoOpen] = useState(true)
  const [isAdditionalInfoOpen, setIsAdditionalInfoOpen] = useState(true)

  const getDefaultAvatar = (name) => {
    return `https://avatar.iran.liara.run/public/boy?username=${name || 'User'}`
  }

  return (
    <Box mt={2}>
      <Box sx={{ padding: '0px 20px' }}>
        <Box display='flex' alignItems='center' mb={2}>
          <Avatar
            src={user.profile_pic || getDefaultAvatar(user.first_name)}
            alt={user.name}
            sx={{ width: 50, height: 50, mr: 2 }}
          />
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2
              }}
            >
              <Typography variant='h6' sx={{ fontWeight: '700' }}>
                {user.name}
              </Typography>
              {user.email_status === 'verified' && (
                <Box
                  component='svg'
                  sx={{
                    width: 18,
                    height: 18,
                    fill: '#3F50F8',
                    verticalAlign: 'middle'
                  }}
                  viewBox='0 0 24 24'
                >
                  <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' />
                </Box>
              )}
            </Box>
            <Typography
              variant='body2'
              color='text.secondary'
              display='flex'
              alignItems='center'
              sx={{
                color: '#8181B0',
                fontWeight: '500'
              }}
            >
              {user.title}
            </Typography>
          </Box>
        </Box>

        {/* Future implementation for adding to campaign or list */}
        {/* <Box display='flex' alignItems='center' mb={2}>
          <Tooltip title='Add to Campaign'>
            <Button
              variant='outlined'
              onClick={handleAddToCampaignClick}
              sx={{
                mr: 1,
                textTransform: 'none',
                border: '1px solid #D1D5DB',
                borderRadius: '8px',
                color: '#6B7280',
                fontWeight: '500',
                padding: '8px 12px',
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: user.email ? '#F9FAFB' : 'white'
                }
              }}
            >
              {isConfirmingLeads
                ? (
                  <CircularProgress size={20} sx={{ color: '#3F50F8' }} />
                  )
                : (
                    'Add to Campaign'
                  )}
            </Button>
          </Tooltip>

          <Tooltip title='Add to List'>
            <Button
              variant='outlined'
              onClick={handleAddToListClick}
              sx={{
                textTransform: 'none',
                border: '1px solid #D1D5DB',
                borderRadius: '8px',
                color: '#6B7280',
                fontWeight: '500',
                padding: '8px 12px',
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'white'
                }
              }}
            >
              Add to List
            </Button>
          </Tooltip>
        </Box> */}
      </Box>

      {/* Contact Information Section */}
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          onClick={() => setIsContactInfoOpen(!isContactInfoOpen)}
          sx={{
            cursor: 'pointer',
            background: '#F2F4F6',
            overflow: 'hidden',
            padding: '5px 20px'
          }}
        >
          <Box display='flex' alignItems='center' sx={{ gap: 2 }}>
            <Typography variant='subtitle1' fontWeight='bold'>
              Contact Information
            </Typography>
          </Box>
          {isContactInfoOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Box>
        <Collapse in={isContactInfoOpen}>
          <Box mt={1} pl={2}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>Email</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                  aria-label={`Email: ${user.email || 'Not available'}`}
                >
                  {user.email ? maskEmail(user.email) : '****@****.com'}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>Phone Number</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap',
                    userSelect: 'none'
                  }}
                >
                  {user.phone_numbers || 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>LinkedIn URL</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {user.linkedin_url || 'N/A'}
                </Typography>
                {user.linkedin_url && (
                  <Box
                    component='a'
                    onClick={() => window.open(user.linkedin_url, '_blank')}
                    sx={{
                      color: '#3F50F8',
                      cursor: 'pointer'
                    }}
                  >
                    <LFWeb />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Collapse>
      </Box>

      {/* Additional Details Section */}
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          onClick={() => setIsAdditionalInfoOpen(!isAdditionalInfoOpen)}
          sx={{
            cursor: 'pointer',
            background: '#F2F4F6',
            overflow: 'hidden',
            padding: '5px 20px'
          }}
        >
          <Box display='flex' alignItems='center' sx={{ gap: 2 }}>
            <Typography variant='subtitle1' fontWeight='bold'>
              Additional Details
            </Typography>
          </Box>
          {isAdditionalInfoOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Box>
        <Collapse in={isAdditionalInfoOpen}>
          <Box mt={1} pl={2}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>Company Name</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {user.company || 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>Industry</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {user.industry || 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>Location</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {[user.city, user.state, user.country].filter(Boolean).join(', ') || 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '12px'
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  marginBottom: '5px'
                }}
              >
                <strong>Company Domain</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {user.company_domain || 'N/A'}
                </Typography>
              </Box>
            </Box>
            {user.company_location && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '12px'
                }}
              >
                <Typography
                  variant='body2'
                  sx={{
                    marginBottom: '5px'
                  }}
                >
                  <strong>Company Location</strong>
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    component='span'
                    sx={{
                      display: 'inline-block',
                      backgroundColor: '#E7F0FF',
                      color: '#3F50F8',
                      borderRadius: '4px',
                      padding: '2px 8px',
                      maxWidth: 'fit-content',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {user.company_location || 'N/A'}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Collapse>
      </Box>
    </Box>
  )
}
